import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { DxDataGridComponent } from 'devextreme-angular';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { Configuration } from '../../core/configuration/configuration';
import { EPaymentType } from '../../core/Enums/EPaymentType.enum';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { Utilidades } from '../../core/helper/utilidades';
import { A3LCompany } from '../../core/models/a3LCompany.model';
import { BolsaVacaciones } from '../../core/models/bolsaVacaciones.model';
import { BolsaVacacionesLiquidacion } from '../../core/models/bolsaVacacionesLiquidacion.model';
import { PeriodosBolsaVacacionesModel } from '../../core/models/periodosBolsaVacaciones.model';
import { SolicitudBolsaVacaciones } from '../../core/models/SolicitudBolsaVacaciones.model';
import { BolsaVacacionesService } from '../../core/services/bolsaVacaciones.service';

@Component({
  selector: 'app-liquidaciones-masivas',
  templateUrl: './liquidaciones-masivas.component.html',
  styleUrls: ['./liquidaciones-masivas.component.scss'],
  providers: [BolsaVacacionesService]
})
export class LiquidacionesMasivasComponent implements OnInit {

  @ViewChild('gridLiquidacion', { static: false }) dataGrid: DxDataGridComponent;

  panelIcon = 'file-invoice-dollar'; // material icon
  panelTitle = 'Liquidación multiple';
  panelDescription = '';
  minDate= new Date();
  maxDate= new Date(this.minDate.getFullYear(), 11, 31);

  holidaysExtraPays: BolsaVacacionesLiquidacion[] = new Array<BolsaVacacionesLiquidacion>();

  fechaLiquidacion: any;
  companies: A3LCompany[] = new Array<A3LCompany>();
  selectedCompany: number;
  selectedYear: number;
  firstHolidays: boolean;
  showFirstHolidaysData: boolean;

  loading: boolean;

  constructor(
    private bolsaVacacionesService: BolsaVacacionesService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _sessionHelper: SessionHelper,
    private _messageDialog: MessageDialog) {
      this.selectedCompany = this._sessionHelper.LastCompanySelectedBolsaVacaciones;
    }

  ngOnInit() {
    setTimeout(() => {
      if(this.selectedCompany){
        this.onSearch();
      }
    }, 60);
  }

  getHolidaysExtraPay(){
    this.bolsaVacacionesService.getToLiquidate(this.selectedCompany, this.selectedYear, this.firstHolidays).subscribe((response: BolsaVacacionesLiquidacion[]) => {
      if (response){
        this.holidaysExtraPays = response;
        this.showFirstHolidaysData = this.firstHolidays;
      }
    });
  }

  // getPeriods(){
  //   this.bolsaVacacionesService.getPeriodsByCompanyAndYear(this.selectedCompany, this.selectedYear).subscribe((response: PeriodosBolsaVacacionesModel[]) => {
  //     if (response){
  //       this.periodos = response;
  //     }
  //   });
  // }

  onSearch() {
    this._sessionHelper.LastCompanySelectedBolsaVacaciones = this.selectedCompany;
    this.getHolidaysExtraPay();
    // this.getPeriods();
  }

  onClickEdit(row: BolsaVacaciones) {
      this._router.navigate([Configuration.editPath, row.Id], {
         relativeTo: this._activatedRoute,
         state: row
      });
  }

  onSelectedTabChange() {
    // console.log(this.dataGrid.dataSource);
    this.dataGrid.instance.repaint();
  }

  onEditorPreparing(e): void {
    if (e.parentType === 'searchPanel') {
        e.editorOptions.stylingMode = 'underlined';
    }
  }

  generarLiquidacion() {


    const solicitudes = new Array<SolicitudBolsaVacaciones>();

    this.dataGrid.instance.getSelectedRowsData().forEach((bolsaVacaciones: BolsaVacaciones) => {

      solicitudes.push({
        CodigoTrabajador: bolsaVacaciones.CodigoTrabajador,
        CodigoEmpresa: bolsaVacaciones.CodigoEmpresa,
        Ejercicio: bolsaVacaciones.Ejercicio,
        Dias: 0,
        CodigoImputacion: bolsaVacaciones.CodigoImputacion,
        A3LVariableConceptId: '',
        A3LExtraPaymentId: '',
        Observaciones: `Liquidación masiva ${Utilidades.getDateString()}`,
        Importe: bolsaVacaciones.Importe,
        FechaSolicitud: this.fechaLiquidacion,
        Destino: EPaymentType.Concept,
        isNew: false
      });

    });

    this.dataGrid.instance.beginCustomLoading('');

    this.bolsaVacacionesService.liquidate(this.selectedCompany, this.selectedYear, solicitudes).subscribe(res => {
      this.getHolidaysExtraPay();
      this.loading = false;
      this.dataGrid.instance.endCustomLoading();
    }, err => {
      this.loading = false;
      this.dataGrid.instance.endCustomLoading();
      this._messageDialog.ShowException(err);
    })

  }
  getFirstHolidayStarDate(data): string {
    if(data.periodos != null && data.periodos.length > 0)
      return data.periodos[0].fechaInicio;
    else
      return ''
  }

  getFirstHolidayEndDate(data): string {
    if(data.periodos != null && data.periodos.length > 0)
      return data.periodos[0].fechaFin;
    else
      return ''
  }

  getFirstHolidayTotalDays(data): string {
    if(data.periodos != null && data.periodos.length > 0)
      return data.periodos[0].dias;
    else
      return ''
  }


}

